var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "withdrawal-widget__success",
      attrs: { "data-test-id": "withdrawal-success" }
    },
    [
      _c("div", { staticClass: "withdrawal-widget__success-text" }, [
        _c(
          "p",
          {
            staticClass: "withdrawal-widget__success-title",
            attrs: { "data-test-id": "withdrawal-success-title" }
          },
          [_vm._v("\n      " + _vm._s(_vm.i18n.withdraw_success()) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "withdrawal-widget__success-amount",
            attrs: { "data-test-id": "withdrawal-success-amount" }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.amount + " " + _vm.selectedAsset) +
                "\n    "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "withdrawal-widget__success-btns" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { "data-test-id": "withdrawal-confirm-reset-btn" },
              on: {
                click: function($event) {
                  return _vm.$emit("resetWidget")
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_go_back()) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "btn md-mint",
              attrs: {
                to: "/history/index/",
                "data-test-id": "withdrawal-confirm-history-btn"
              }
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.i18n.lbl_view_history()) + "\n    "
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30338b03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30338b03","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/widgets/WithdrawalWidget/WithdrawalSuccess.vue
// module id = lDdx
// module chunks = 1